import * as React from 'react';
import { makeIcon } from './makeIcon';
const StartFilled = props => (React.createElement("svg", Object.assign({ width: '16px', height: '16px', viewBox: '0 0 16 16' }, props),
    React.createElement("g", { stroke: 'none', "stroke-width": '1', "fill-rule": 'evenodd' },
        React.createElement("polygon", { points: '8 11.9478947 12.326 14.5 11.178 9.69 15 6.45368421 9.967 6.03631579 8 1.5 6.033 6.03631579 1 6.45368421 4.822 9.69 3.674 14.5' }))));
export const StartFilledIcon = makeIcon('starFilled')(StartFilled);
//# sourceMappingURL=StarFilled.js.map